import { Navigate, Outlet } from "react-router-dom";
import { getCookie } from "../utils/cookies";

const LOGIN_PATH_BY_ROLE = {
  owner: "/login_fleetowner",
  customer: "/login_customer",
};

// requiredRole: "owner" | "customer" — which account type is allowed through.
export default function ProtectedRoute({ requiredRole }) {
  const token = getCookie("token");

  let user = null;
  try {
    user = JSON.parse(getCookie("user"));
  } catch {
    user = null;
  }

  if (!token || user?.role !== requiredRole) {
    return <Navigate to={LOGIN_PATH_BY_ROLE[requiredRole] || "/"} replace />;
  }

  return <Outlet />;
}
